module.exports = __webpack_public_path__ + "static/sport/bgi-h5.ef88d87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport3/bgi-h5.jpg
// module id = Uitw
// module chunks = 0